import { messages } from "./messages";

// this text is sent in the payload of API calls to check consent status, and update consent status.
// when updated, users will be shown the consent page again, and be prompted to consent again.
export const CONSENT_PAGE_LEGAL_DISPLAY_TEXT_VERSION: string =
    messages.legalConsentPortalFeature_LegalAgreementCheckboxText
        .defaultMessage;
